import { jwtDecode } from "jwt-decode";

const AUTH_STORAGE_KEYS = ["psx_token", "user_type", "login_time"];
const PUBLIC_AUTH_PATHS = new Set(["/", "/register", "/resetpassword", "/verify-email"]);

const getStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage;
};

export const clearAuthSession = () => {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  AUTH_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
};

export const persistAuthSession = ({ token, userType }) => {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  storage.setItem("psx_token", token || "");
  storage.setItem("user_type", String(userType ?? ""));
  storage.removeItem("login_time");
};

export const getStoredAuthToken = () => {
  const storage = getStorage();
  if (!storage) {
    return "";
  }

  return storage.getItem("psx_token") || "";
};

export const decodeStoredAuthToken = (token = getStoredAuthToken()) => {
  if (!token || token === "undefined") {
    return {};
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Invalid auth token:", error);
    clearAuthSession();
    return {};
  }
};

export const hasValidAuthSession = () => {
  const token = getStoredAuthToken();
  if (!token) {
    return false;
  }

  const decoded = decodeStoredAuthToken(token);
  if (!decoded || Object.keys(decoded).length === 0) {
    return false;
  }

  return true;
};

export const isPublicAuthPath = (pathname = "") => PUBLIC_AUTH_PATHS.has(pathname);

export const redirectToLogin = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (isPublicAuthPath(window.location.pathname)) {
    return;
  }

  window.location.replace("/");
};

export const handleUnauthorizedSession = () => {
  clearAuthSession();
  redirectToLogin();
};
